module.exports = __webpack_public_path__ + "img/ds2.7073c746.png";